var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-white",class:{ 'flex-centered': _vm.isFlexCentered() },attrs:{"id":"layout"}},[_c('AppHeaderBar'),_c('v-main',[_c('v-sheet',{staticClass:"page-white",attrs:{"id":"content"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }